window.addEventListener("load", function () {
    const isLg = () => window.matchMedia("(min-width: 1024px)").matches;
    const isMd = () => window.matchMedia("(min-width: 768px)").matches;

    // All collapses
    document.querySelectorAll(".collapse-nav").forEach((element) => {
        new Collapse(element);
    });

    // SPA category filter
    if (document.querySelector('.filter-toggle')) {
        var filterToggle = document.querySelector('.filter-toggle');
        var filterContainer = document.querySelector('.filter-container');
        filterToggle.onclick = function () {
            filterToggle.classList.toggle('active-filter');
            filterContainer.classList.toggle('active-filter');
        }

        const filterBtn = document.querySelectorAll('.filterBtn');
        const filterElements = document.querySelectorAll('.filterItem');

        filterBtn.forEach(function (button) {
            button.addEventListener('click', function () {
                const buttonText = button.innerText;
                if (buttonText == 'ALLA') {
                    document.querySelector('.filter-toggle strong').innerText='Filtrera behandlingar';
                } else {
                    document.querySelector('.filter-toggle strong').innerText=buttonText;
                }
                document.querySelector('.filter-toggle').classList.remove('active-filter');
                document.querySelector('.filter-container').classList.remove('active-filter');
                document.querySelector('.active').classList.remove('active');
                button.classList.add('active');
                const value = button.dataset.terms;
                [...filterElements].forEach((element) => {
                    element.classList.add('hidden');
                    if (value !== 'alla') {
                        const terms = element.dataset.terms;
                        const match = terms.split(', ');
                        if (match.indexOf(value) > -1) {
                            element.classList.remove('hidden');
                        }
                    } else {
                        element.classList.remove('hidden');
                    }
                });
            });
        })
    }

    // Instagram slider
    if (document.querySelector(".instagram-slider")) {
        new Splide(".instagram-slider", {
            perPage: isLg() ? 4 : isMd() ? 2 : 1,
            gap: 40,
        }).mount();
    }

    // Grid card slider
    if (document.querySelector(".grid_card-slider")) {
        let options = {
            perPage: isLg() ? 3 : isMd() ? 2 : 1,
            gap: 40,
            arrows: false,
        };

        if (!isMd()) {
            options.fixedWidth = window.innerWidth - 60;
            options.gap = 16;
        }
        const slider = new Splide(".grid_card-slider", options);

        slider.on("pagination:mounted", function (data) {
            // You can add your class to the UL element
            data.list.classList.add("grid-card-slider-pagination");

            // `items` contains all dot items
            data.items.forEach(function (item) {
                item.button.innerHTML = "<span class='icon-rombus'></span>";
            });
        });

        slider.mount();
    }

    // Inspiration slider
    if (document.querySelector(".inspiration-slider")) {
        let options = {
            perPage: isLg() ? 3 : isMd() ? 2 : 1,
            gap: 40,
            arrows: false,
        };

        if (!isMd()) {
            options.fixedWidth = window.innerWidth - 60;
            options.gap = 16;
        }

        const slider = new Splide(".inspiration-slider", options);

        slider.on("pagination:mounted", function (data) {
            // You can add your class to the UL element
            data.list.classList.add("grid-card-slider-pagination");

            // `items` contains all dot items
            data.items.forEach(function (item) {
                item.button.innerHTML = "<span class='icon-rombus'></span>";
            });
        });

        slider.mount();
    }

    if (document.querySelector(".package-deal-slider")) {
        new Splide(".package-deal-slider", {
            perPage: 1,
        }).mount();
    }

    // Full card slider
    if (document.querySelector(".full_card_slider")) {
        document.querySelectorAll(".full_card_slider").forEach((element) => {
            new Splide(element, {
                perPage: 1,
                gap: 0,
                arrows: false,
                pagination: false,
            }).mount();
        });
    }


    // Burger menu
    if (document.querySelector(".opening-hours-button")) {
        document
            .querySelector(".opening-hours-button")
            .addEventListener("click", function () {
                document
                    .querySelector(".opening-hours")
                    .classList.remove("translate-x-full");
                document.body.classList.add("overflow-hidden");
            });
        document
            .querySelector(".opening-hours-close")
            .addEventListener("click", function () {
                document
                    .querySelector(".opening-hours")
                    .classList.add("translate-x-full");
                document.body.classList.remove("overflow-hidden");
            });
    }


    const nav = document.querySelector(".page-nav");
// Page nav
    if (!isMd() && nav) {
        const menu = nav.querySelector("ul");
        const menuItems = Array.from(menu.querySelectorAll("li"));

        const left_padding =
            (window.innerWidth - 32 - menuItems[0].getBoundingClientRect().width) / 2;
        const right_padding =
            (window.innerWidth -
                32 -
                menuItems[menuItems.length - 1].getBoundingClientRect().width) /
            2;

        let scrollValue = 0;

        menu.style.margin = `0 ${right_padding}px 0 ${left_padding}px`;

        for (let i = 0; i < menuItems.length; i++) {
            const navItem = menuItems[i];
            if (navItem.classList.contains("current_page_item")) {
                if (i !== 0) {
                    scrollValue += navItem.getBoundingClientRect().width / 2;
                }
                break;
            } else {
                if (i === 0) {
                    scrollValue += navItem.getBoundingClientRect().width / 2;
                } else {
                    scrollValue += navItem.getBoundingClientRect().width;
                }
                scrollValue += 32;
            }
        }

        nav.scrollTo({
            top: 0,
            left: scrollValue,
        });

        // Arrows
        const arrows = nav.querySelectorAll(".page-nav-arrows > a");
        const prevArrow = arrows[0];
        const nextArrow = arrows[1];

        const activeMenuItem = menu.querySelector("li.current_page_item");
        const prevSibling = activeMenuItem.previousElementSibling;

        if (prevSibling) {
            prevArrow.classList.remove("bg-opacity-50");
            prevArrow.setAttribute(
                "href",
                prevSibling.querySelector("a").getAttribute("href")
            );
        }

        const nextSibling = activeMenuItem.nextElementSibling;

        if (nextSibling) {
            nextArrow.classList.remove("bg-opacity-50");
            nextArrow.setAttribute(
                "href",
                nextSibling.querySelector("a").getAttribute("href")
            );
        }
    }

    // header scroll
    if (document.querySelector('.site-header')) {
      const body = document.body;
      const scrollUp = "scroll-up";
      const scrollDown = "scroll-down";
      let lastScroll = 0;

      window.addEventListener("scroll", () => {
        const currentScroll = window.scrollY;
        if (currentScroll <= 0) {
          body.classList.remove(scrollUp);
          return;
        }

        if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
          // down
          body.classList.remove(scrollUp);
          body.classList.add(scrollDown);
        } else if (
            currentScroll < lastScroll &&
            body.classList.contains(scrollDown)
        ) {
          // up
          body.classList.remove(scrollDown);
          body.classList.add(scrollUp);
        }
        lastScroll = currentScroll;
      });
    }
});



// Burger menu
if (document.querySelector(".burger-menu-button")) {
    document
        .querySelector(".burger-menu-button")
        .addEventListener("click", function () {
            document
                .querySelector(".burger-menu")
                .classList.remove("-translate-x-full");
            document.body.classList.add("overflow-hidden");
        });
    document
        .querySelector(".burger-menu-close")
        .addEventListener("click", function () {
            document
                .querySelector(".burger-menu")
                .classList.add("-translate-x-full");
            document.body.classList.remove("overflow-hidden");
        });
}